var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:` align-self-center text-status px-3 mr-5 ${_vm.variant}`},[_vm._v(" "+_vm._s(_vm.status)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }